import * as React from "react";
import { Icon } from "@nju/icons";
import { Button, Separator, Text } from "@nju/ui";
import { formatPrice } from "@nju/utils";

interface IDiscountWarningModalProps {
  onConfirm: () => void;
  onClose: () => void;
  isSaving: boolean;
  activationFee: number;
  activationFeeWithConsentsDiscount: number;
  multiOrderItemsCount?: number;
}

export function DiscountWarningModal({
  onClose,
  onConfirm,
  isSaving,
  activationFee,
  activationFeeWithConsentsDiscount,
  multiOrderItemsCount,
}: IDiscountWarningModalProps) {
  return (
    <div className="mt-4">
      <div className="border-2 border-geyser rounded-[12px] p-4">
        <div className="flex items-center gap-2">
          <Icon
            height={24}
            name="exclamation-circle"
            tone="accent"
            width={24}
          />
          <Text size="xl" weight="bold">
            zaznacz zgody i zaoszczędź
          </Text>
        </div>
        <Separator size="m" />
        <div className="flex flex-col">
          <Text size="l">
            Jeśli zaznaczysz zgody – otrzymasz rabat – nie płacisz opłaty
            aktywacyjnej.
          </Text>
          <Text className="mb-2" size="l">
            Jeśli ich nie zaznaczysz – zapłacisz jednorazową opłatę aktywacyjną{" "}
            {activationFee} zł
            {multiOrderItemsCount && multiOrderItemsCount > 1
              ? " za każdy numer."
              : "."}
          </Text>
        </div>
        <Separator size="xs" tone="invisible" />
        <Text className="my-3" size="l" weight="bold">
          Czy chcesz otrzymać rabat?
        </Text>
        <div className="flex only-mobile:flex-col-reverse mt-4 gap-4 only-mobile:gap-2">
          <Button
            isLoading={isSaving}
            onPress={onConfirm}
            size={{ "@onlyMobile": "s" }}
            variant="secondary"
          >
            nie chcę rabatu
          </Button>
          <Button onPress={onClose} size={{ "@onlyMobile": "s" }}>
            tak, wróć po rabat
          </Button>
        </div>
      </div>
      <div className="border-2 border-geyser rounded-[12px] px-4 py-6 mt-4">
        <Text size="keySM" weight="bold">
          szczegóły opłaty
        </Text>
        <Separator size="m" tone="invisible" />
        <Text size="m">
          opłata aktywacyjna bez rabatu
          {multiOrderItemsCount && multiOrderItemsCount > 1
            ? " za każdy numer:"
            : ":"}{" "}
          {formatPrice(activationFee)} zł
          <br />
          {`opłata aktywacyjna z rabatem: ${formatPrice(
            activationFeeWithConsentsDiscount,
          )} zł`}
        </Text>
      </div>
    </div>
  );
}
